/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizationsettings_Updateorganization2Inputs */

const zh_organizationsettings_updateorganization2 = /** @type {(inputs: Organizationsettings_Updateorganization2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新组织`)
};

const en_organizationsettings_updateorganization2 = /** @type {(inputs: Organizationsettings_Updateorganization2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update Organization`)
};

const es_organizationsettings_updateorganization2 = /** @type {(inputs: Organizationsettings_Updateorganization2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizar organización`)
};

/**
* | output |
* | --- |
* | "Update Organization" |
*
* @param {Organizationsettings_Updateorganization2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const organizationsettings_updateorganization2 = /** @type {((inputs?: Organizationsettings_Updateorganization2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizationsettings_Updateorganization2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_organizationsettings_updateorganization2(inputs)
	if (locale === "en") return en_organizationsettings_updateorganization2(inputs)
	return es_organizationsettings_updateorganization2(inputs)
});
export { organizationsettings_updateorganization2 as "organizationSettings_updateOrganization" }